var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoBar",class:[
    'infoBar',
    `infoBar--${_vm.layout}`,
    {
      'infoBar--disablePaddings': _vm.disablePaddings,
    },
  ]},[_c('div',{class:[
      'infoBar__inner',
      {
        'infoBar__closeButton--withClose': _vm.withClose,
      },
    ]},[_c('span',{class:['infoBar__icon', `icon-${_vm.icon}`],style:(`color: ${_vm.color}`)}),_vm._v(" "),_c('span',{staticClass:"infoBar__message",domProps:{"innerHTML":_vm._s(_vm.cleanHtml)}}),_vm._v(" "),_c('span',{class:['infoBar__closeButton', { 'infoBar__closeButton--visible': _vm.withClose }],on:{"click":function($event){return _vm.$emit('close')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }